// Sticky palette from the design handoff: theme-invariant, note text is always the ink color
export const YELLOW = "#f6e05e"
export const PEACH = "#fcd9a8"
export const PINK = "#f9a8d4"
export const MINT = "#a7f3d0"
export const LIGHT_BLUE = "#bfdbfe"
export const LIGHT_PURPLE = "#ddd6fe"
export const WHITE = "#ffffff"
export const TRANSPARENT = "#ffffff00"
export const STICKY_INK = "#2b2a33"
// legacy aliases still referenced by tutorial content / github webhook
export const RED = "#f9a8d4"
export const LIGHT_GREEN = MINT
export const ORANGE = PEACH
export const BLACK = STICKY_INK
export const LIGHT_GRAY = "#f2f2f5"
export const DEFAULT_NOTE_COLOR = YELLOW

export const NOTE_COLORS = [
    { name: "yellow", color: YELLOW },
    { name: "peach", color: PEACH },
    { name: "pink", color: PINK },
    { name: "mint", color: MINT },
    { name: "blue", color: LIGHT_BLUE },
    { name: "violet", color: LIGHT_PURPLE },
    { name: "white", color: WHITE },
    { name: "transparent", color: TRANSPARENT },
]
